<script>
  import ArrowLink from "../../../Common/ArrowLink.svelte";
  import { appState, queryState } from "../../../../stores";

  // State
  $: ({ currentPage, numberOfResults, reports } = $appState);
  $: lastPage = Math.ceil(numberOfResults / 25);
  $: pages =
    Math.ceil(reports.length / 25) < 9
      ? Array.from(Array(Math.ceil(reports.length / 25)), (_, i) => i + 1)
      : Array.from(Array(9), (_, i) => i + 1);

  // Action
  function goToPage(n) {
    queryState.update((queryState) => ({ ...queryState, pg: n }));
    scrollTo(0, 0);
  }
</script>

{#if pages?.length}
  <div id="reports-search-pagination-buttons">
    {#if currentPage > 9}
      <ArrowLink
        button
        buttonSubmit={() => goToPage(1)}
        text="First"
        reverse
        double
      />
    {/if}
    {#if currentPage > 1}
      <ArrowLink
        button
        buttonSubmit={() => goToPage(currentPage - 1)}
        text="Prev"
        reverse
      />
    {/if}
    {#each pages as page}
      <button
        on:click|preventDefault={goToPage(page)}
        style={page === currentPage && "color: #4A4A4A;"}
      >
        {page}
      </button>
    {/each}
    <button on:click|preventDefault> ... </button>
    <button
      on:click|preventDefault={goToPage(lastPage)}
      style={lastPage === currentPage && "color: #4A4A4A;"}
    >
      {lastPage}
    </button>
    {#if currentPage !== lastPage}
      <ArrowLink
        button
        buttonSubmit={() => goToPage(currentPage + 1)}
        text="Next"
      />
      {#if currentPage < lastPage - 4}
        <div style="width: 8px;" />
        <ArrowLink
          button
          buttonSubmit={() => goToPage(lastPage)}
          text="Last"
          double
        />
      {/if}
    {/if}
  </div>
{/if}

<style>
  #reports-search-pagination-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  button {
    font-family: "Segoe UI", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #006b97;
    border: none;
    background: transparent;
    cursor: pointer;
    margin-right: 8px;
  }
</style>
